<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      <i [class]="modoAdicionarContato ? 'fas fa-user-plus me-2' : 'fas fa-project-diagram me-2'"></i>
      {{ modoAdicionarContato ? 'Adicionar Contato' : (event ? 'Editar Projeto: ' + event.descricao : 'Novo Projeto') }}
    </h5>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="projetoForm" (ngSubmit)="onSubmit()">
      <input type="hidden" formControlName="id">
      <!-- Campo Descrição (oculto no modo adicionar contato) -->
      <div class="mb-3" *ngIf="!modoAdicionarContato">
        <label for="descricao" class="form-label">
          Descrição <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control form-control-sm"
          id="descricao"
          formControlName="descricao"
          placeholder="Digite a descrição do projeto"
          [class.is-invalid]="projetoForm.get('descricao')?.invalid && projetoForm.get('descricao')?.touched"
        >
        <div class="invalid-feedback" *ngIf="projetoForm.get('descricao')?.invalid && projetoForm.get('descricao')?.touched">
          Descrição é obrigatória.
        </div>
      </div>

      <!-- Campo Cliente (apenas se não tiver clienteId fornecido) -->
      <div class="mb-3" *ngIf="!clienteId">
        <label for="clienteId" class="form-label">
          Cliente <span class="text-danger">*</span>
        </label>
        
        <div class="position-relative">
          <div class="dropdown" [class.show]="dropdownClienteAberto">
            <input
              type="text"
              class="form-control form-control-sm dropdown-toggle"
              [class.is-invalid]="projetoForm.get('clienteId')?.invalid && projetoForm.get('clienteId')?.touched"
              placeholder="Selecione um cliente..."
              [(ngModel)]="buscaCliente"
              (input)="onBuscaClienteChange(); buscaClienteDebounce$.next(buscaCliente || '')"
              (focus)="abrirDropdownCliente()"
              (blur)="fecharDropdownCliente()"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
            >
            
            <div 
              class="dropdown-menu w-100" 
              [class.show]="dropdownClienteAberto" 
              style="max-height: 200px; overflow-y: auto;"
              (scroll)="onScrollClientes($event)"
            >
              <div *ngIf="clientesFiltrados.length === 0 && !clientePaginas.carregandoMais" class="dropdown-item-text text-muted">
                Nenhum cliente encontrado
              </div>
              <a 
                *ngFor="let cliente of clientesFiltrados" 
                class="dropdown-item" 
                href="#"
                (click)="$event.preventDefault()"
                (mousedown)="selecionarCliente(cliente)"
              >
                {{ cliente.nome }}
              </a>
              <div *ngIf="clientePaginas.carregandoMais" class="dropdown-item-text text-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>
            </div>
          </div>
          
          <select
            id="clienteId"
            class="d-none"
            formControlName="clienteId"
          >
            <option value="">Selecione um cliente</option>
          </select>
        </div>
        
        <div class="invalid-feedback d-block" *ngIf="projetoForm.get('clienteId')?.invalid && projetoForm.get('clienteId')?.touched">
          Cliente é obrigatório.
        </div>
      </div>
      
      <input type="hidden" formControlName="clienteId" *ngIf="clienteId">

      <!-- Campo Feira -->
      <div class="mb-3">
        <label for="feiraClienteId" class="form-label">
          Feira <span class="text-danger">*</span>
        </label>
        
        <div class="position-relative">
          <div class="dropdown" [class.show]="dropdownFeiraAberto">
            <input
              type="text"
              class="form-control form-control-sm dropdown-toggle"
              [class.is-invalid]="projetoForm.get('feiraClienteId')?.invalid && projetoForm.get('feiraClienteId')?.touched"
              [disabled]="!projetoForm.get('clienteId')?.value"
              placeholder="Selecione uma feira..."
              [(ngModel)]="buscaFeira"
              (input)="buscaFeiraDebounce$.next(buscaFeira || '')"
              (focus)="abrirDropdownFeira()"
              (blur)="fecharDropdownFeira()"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
            >
            
            <div 
              class="dropdown-menu w-100" 
              [class.show]="dropdownFeiraAberto" 
              style="max-height: 200px; overflow-y: auto;"
            >
              <div *ngIf="feirasFiltradas.length === 0 && !feiraPaginas.carregandoMais" class="dropdown-item-text text-muted">
                Nenhuma feira encontrada
              </div>
              <a 
                *ngFor="let feira of feirasFiltradas" 
                class="dropdown-item" 
                href="#"
                (click)="$event.preventDefault()"
                (mousedown)="selecionarFeira(feira)"
              >
                {{ feira.nome }}
              </a>
              <div *ngIf="feiraPaginas.carregandoMais" class="dropdown-item-text text-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>
            </div>
          </div>
          
          <select
            id="feiraClienteId"
            class="d-none"
            formControlName="feiraClienteId"
          >
            <option value="">Selecione uma feira</option>
          </select>
        </div>
        
        <div class="invalid-feedback d-block" *ngIf="projetoForm.get('feiraClienteId')?.invalid && projetoForm.get('feiraClienteId')?.touched">
          Feira é obrigatória.
        </div>
        <small class="form-text text-muted" *ngIf="!projetoForm.get('clienteId')?.value && !clienteId">
          Selecione um cliente primeiro para carregar as feiras.
        </small>
      </div>

      <!-- Campo Status (apenas na edição e não no modo adicionar contato) -->
      <div class="mb-3" *ngIf="event && !modoAdicionarContato">
        <label for="statusProjeto" class="form-label">
          Status do Projeto <span class="text-danger">*</span>
        </label>
        <select 
          class="form-select form-select-sm" 
          formControlName="statusProjeto"
          [disabled]="event && isStatusBloqueado(event.statusProjeto?.statusProjeto)"
          [ngClass]="{
            'is-invalid':
            projetoForm.controls.statusProjeto.errors &&
            projetoForm.get('statusProjeto')?.touched,
          }"
        >
          <option value="">Selecione um status</option>
          <option value="0">Iniciado</option>
          <option value="3">Negociando</option>
          <option value="1">Aprovado</option>
          <option value="2">Reprovado</option>
        </select>
        <div class="invalid-feedback" *ngIf="projetoForm.get('statusProjeto')?.touched && projetoForm.get('statusProjeto')?.invalid">
          Selecione um Status.
        </div>
      </div>

      <!-- Datas da Feira (oculto no modo adicionar contato) -->
      <div class="row mb-3" *ngIf="!modoAdicionarContato">
        <div class="col-md-6">
          <label for="dataInicioFeira" class="form-label">
            Data Início Feira
          </label>
          <input
            type="date"
            class="form-control form-control-sm"
            id="dataInicioFeira"
            formControlName="dataInicioFeira"
            (change)="onDataInicioChange()"
            [class.is-invalid]="(projetoForm.get('dataInicioFeira')?.invalid || projetoForm.errors?.['datasIncompletas'] || projetoForm.errors?.['dataFimMenor']) && projetoForm.get('dataInicioFeira')?.touched"
          >
          <div class="invalid-feedback" *ngIf="projetoForm.errors?.['datasIncompletas'] && projetoForm.get('dataInicioFeira')?.touched">
            Se uma data for preenchida, ambas devem ser preenchidas.
          </div>
          <div class="invalid-feedback" *ngIf="projetoForm.errors?.['dataFimMenor'] && projetoForm.get('dataInicioFeira')?.touched">
            A data fim não pode ser menor que a data início.
          </div>
        </div>
        <div class="col-md-6">
          <label for="dataFimFeira" class="form-label">
            Data Fim Feira
          </label>
          <input
            type="date"
            class="form-control form-control-sm"
            id="dataFimFeira"
            formControlName="dataFimFeira"
            [min]="getDataMinimaParaFim()"
            (change)="onDataFimChange()"
            [class.is-invalid]="(projetoForm.get('dataFimFeira')?.invalid || projetoForm.errors?.['datasIncompletas'] || projetoForm.errors?.['dataFimMenor']) && projetoForm.get('dataFimFeira')?.touched"
          >
          <div class="invalid-feedback" *ngIf="projetoForm.errors?.['datasIncompletas'] && projetoForm.get('dataFimFeira')?.touched">
            Se uma data for preenchida, ambas devem ser preenchidas.
          </div>
          <div class="invalid-feedback" *ngIf="projetoForm.errors?.['dataFimMenor'] && projetoForm.get('dataFimFeira')?.touched">
            A data fim não pode ser menor que a data início.
          </div>
        </div>
      </div>

      <!-- Dimensões do Stand (oculto no modo adicionar contato) -->
      <div class="row mb-3" *ngIf="!modoAdicionarContato">
        <div class="col-md-6">
          <label for="comprimento" class="form-label">
            Comprimento do Stand (m)
          </label>
          <input
            formControlName="comprimento"
            mask="separator.2"
            thousandSeparator="."
            decimalMarker=","
            [dropSpecialCharacters]="false"
            type="text"
            class="form-control form-control-sm"
            id="comprimento"
            placeholder="Digite o comprimento..."
          >
        </div>
        <div class="col-md-6">
          <label for="largura" class="form-label">
            Largura do Stand (m)
          </label>
          <input
            formControlName="largura"
            mask="separator.2"
            thousandSeparator="."
            decimalMarker=","
            [dropSpecialCharacters]="false"
            type="text"
            class="form-control form-control-sm"
            id="largura"
            placeholder="Digite a largura..."
          >
        </div>
      </div>

      <!-- Dimensões Sobrepor (oculto no modo adicionar contato) -->
      <div class="row mb-3" *ngIf="!modoAdicionarContato">
        <div class="col-md-6">
          <label for="comprimentoSobrepor" class="form-label">
            Comprimento Sobrepor (m)
          </label>
          <input
            formControlName="comprimentoSobrepor"
            mask="separator.2"
            thousandSeparator="."
            decimalMarker=","
            [dropSpecialCharacters]="false"
            type="text"
            class="form-control form-control-sm"
            id="comprimentoSobrepor"
            placeholder="Digite o comprimento sobrepor..."
            (blur)="onComprimentoSobreporChange()"
            [class.is-invalid]="projetoForm.errors?.['sobreporIncompleto'] && projetoForm.get('comprimentoSobrepor')?.touched"
          >
          <div class="invalid-feedback" *ngIf="projetoForm.errors?.['sobreporIncompleto'] && projetoForm.get('comprimentoSobrepor')?.touched">
            Se um campo de sobrepor for preenchido, ambos devem ser preenchidos.
          </div>
        </div>
        <div class="col-md-6">
          <label for="larguraSobrepor" class="form-label">
            Largura Sobrepor (m)
          </label>
          <input
            formControlName="larguraSobrepor"
            mask="separator.2"
            thousandSeparator="."
            decimalMarker=","
            [dropSpecialCharacters]="false"
            type="text"
            class="form-control form-control-sm"
            id="larguraSobrepor"
            placeholder="Digite a largura sobrepor..."
            (blur)="onLarguraSobreporChange()"
            [class.is-invalid]="projetoForm.errors?.['sobreporIncompleto'] && projetoForm.get('larguraSobrepor')?.touched"
          >
          <div class="invalid-feedback" *ngIf="projetoForm.errors?.['sobreporIncompleto'] && projetoForm.get('larguraSobrepor')?.touched">
            Se um campo de sobrepor for preenchido, ambos devem ser preenchidos.
          </div>
        </div>
      </div>

      <!-- Botões -->
      <div class="text-end">
        <button type="button" class="btn btn-outline-secondary btn-sm me-2" (click)="activeModal.dismiss()">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary btn-sm" [disabled]="salvando">
          <span *ngIf="salvando" class="spinner-border spinner-border-sm me-2" role="status"></span>
          {{ modoAdicionarContato ? 'Adicionar Na lista' : (event ? 'Atualizar' : 'Salvar') }}
        </button>
      </div>
    </form>
  </div>
</div>

